import req from './req'

// 页面风格配置-获取配置详情接口
export function getPageSetting (params) {
  return req.get('/setting/page-setting', params)
}

// 页面风格配置-保存配置详情接口
export function postPageSetting (params) {
  return req.post('/setting/page-setting', params)
}

// 获取角色列表
export function getRolesList (params) {
  return req.get('/jurisdiction/role', params)
}

// 设置角色
export function updateRole (userId, params) {
  return req.post('/jurisdiction/user/update-role/' + userId, params)
}

// 同步企业微信
export function syncDepartment (params) {
  return req.post('/workwechat/department-user/sync', params)
}

// 获取角色详情
export function getRolesInfo (id, params) {
  return req.get('/jurisdiction/role/' + id, params)
}

// 获取站点后台列表
export function getAdminList (params) {
  return req.get('/it/site/admin_list', params)
}

// 设置角色名称
export function editRole (roleId, params) {
  return req.post('/jurisdiction/role/update/' + roleId, params)
}

/**
 * 账号信息
 */
// 获取用户信息
export function getAccountInfo (params) {
  return req.get('/account-info', params)
}

// 获取公司信息
export function getCompanyInfo (params) {
  return req.get('/external/base/company-info', params)
}

// 获取短信签名接口
export function getSign (params) {
  return req.get('/setting/sms/sign', params)
}

// 获取短信签名接口
export function setSign (params) {
  return req.post('/setting/sms/sign', params)
}